import { render } from "./InfiniteScrollWrapper.vue?vue&type=template&id=fd33e13e"
import script from "./InfiniteScrollWrapper.vue?vue&type=script&lang=js"
export * from "./InfiniteScrollWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__